<template>
  <div id="header" class="bg-light">
    <nav class="navbar navbar-expand-md navbar-light">
      <div :class="{'container': screenWidth>=992, 'container-fluid': screenWidth<992}">
        <router-link class="navbar-brand p-0" :to="{name: 'Home'}">
          <img class="logo" src="@/assets/image/logo-header.png" alt="logo" />
        </router-link>
        <button
          type="button"
          class="hamburger hamburger--collapse d-md-none d-flex flex-column align-items-center justify-content-center"
          :class="{'is-active': show}"
          @click.prevent="show = !show"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
        <transition name="slide">
          <div
            id="navbarContent"
            class="collapse navbar-collapse"
            v-if="screenWidth>=768 || screenWidth<768 && show"
            :class="{'show': show}"
          >
            <ul class="navbar-nav ml-auto h-100">
              <li class="nav-item" :class="{active: currentPage === 'News'}">
                <router-link class="nav-link" :to="{name:'News'}">最新消息</router-link>
              </li>
              <li class="nav-item" :class="{active: currentPage === 'Service'}">
                <router-link class="nav-link" :to="{name:'Service'}">HS超集點</router-link>
              </li>
              <li
                class="nav-item"
                :class="{active: ['Special-Offer', 'Coupon'].indexOf(currentPage)>=0 }"
              >
                <router-link class="nav-link" :to="{name: 'Special-Offer'}">會員專屬優惠</router-link>
              </li>
              <li class="nav-item" :class="{active: currentPage === 'Partners'}">
                <router-link class="nav-link" :to="{name:'Partners'}">合作商家</router-link>
              </li>
              <!-- <li class="nav-item" :class="{active: currentPage === 'Collaboration'}">
                <a class="nav-link" href="#" @click.prevent="goToSection('Collaboration')">合作商家</a>
              </li>-->
            </ul>
            <div class="closed d-md-none" @click.prevent="show = !show">
              <button type="button" class="btn btn-outline-primary-light">
                <Icons name="closed" />
              </button>
            </div>
          </div>
        </transition>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icons from '@/components/icon.vue';

export default {
  name: 'Header',
  components: {
    Icons,
  },
  computed: {
    ...mapGetters(['screenWidth']),
    currentPage() {
      return this.$route.name;
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    goToSection(section) {
      if (this.$route.name === 'Home') {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$emit('goToSection', section);
          }, 800);
        });
      } else {
        this.$router.push({ name: 'Home', params: { section } });
      }
      this.show = false;
    },
  },
  watch: {
    screenWidth() {
      if (this.screenWidth >= 768) {
        this.show = false;
      }
    },
    $route() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss">
#header {
  nav {
    position: relative;
    padding: 0;
    background: linear-gradient(to bottom, white 25%, $secondary-white 100%);
    &::before {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: -5px;
      z-index: -1;
      background-color: $primary-light;
    }
    .navbar-brand {
      margin: 10px 15px;
      @media (min-width: 768px) {
        margin: 0;
      }
      .logo {
        height: 40px;
        @media (min-width: 768px) {
          height: 50px;
        }
        @media (min-width: 992px) {
          height: 50px;
        }
      }
    }
    .hamburger {
      transition-property: opacity, filter;
      transition: 0.15s ease-out;
      text-transform: none;
      background-color: transparent;
      border: 0;
      margin: 10px 15px;
      overflow: visible;
      .hamburger-box {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 24px;
        .hamburger-inner {
          &,
          &::before,
          &::after {
            content: '';
            display: block;
            position: absolute;
            width: 30px;
            height: 4px;
            background-color: $primary-light;
            border-radius: 4px;
            transition-property: transform;
            transition: 0.15s ease-out;
          }
          &::before {
            top: -10px;
          }
          &::after {
            bottom: -10px;
          }
          &:hover {
            background-color: $primary;
            &::before,
            &::after {
              background-color: $primary;
            }
          }
        }
      }
    }
    .hamburger--collapse {
      .hamburger-inner {
        top: auto;
        bottom: 0;
        transition-delay: 0.13s;
        transition: 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
        &::after {
          top: -20px;
          transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear;
        }
        &::before {
          transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
            transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
        }
      }
      &.is-active {
        .hamburger-inner {
          transform: translate3d(0, -10px, 0) rotate(-45deg);
          transition-delay: 0.22s;
          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
          &::after {
            top: 0;
            opacity: 0;
            transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
              opacity 0.1s 0.22s linear;
          }
          &::before {
            top: 0;
            transform: rotate(-90deg);
            transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
              transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
          }
        }
      }
    }
    .collapse {
      position: fixed;
      background-color: black;
      top: 0;
      bottom: 0;
      left: 20px;
      right: 0;
      padding: 80px 0;
      @media (min-width: 768px) {
        position: initial;
        background-color: transparent;
        padding: 0;
      }
      ul {
        .nav-item {
          padding: 15px 20px;
          background-size: 200% 200%;
          transition: background-position 0.5s ease-out;
          background-image: linear-gradient(to left, $primary 50%, transparent 0);
          background-position: left;
          text-align: center;
          font-size: 20px;
          @media (min-width: 768px) {
            font-size: 16px;
            background-image: linear-gradient(to top, $primary 50%, transparent 0);
            background-position: top;
          }
          a {
            transition: 0.5s ease-out;
            color: $primary-light;
            font-weight: $font-weight-medium;
          }
          &:hover,
          &.active {
            background-position: right;
            @media (min-width: 768px) {
              background-position: bottom;
            }
            a {
              color: $sub-primary;
            }
          }
        }
      }
      .closed {
        position: absolute;
        bottom: 80px;
        left: 0;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          border: 4px solid $primary-light;
          padding: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            fill: $primary-light;
          }
          &:hover {
            background-color: transparent;
            border-color: $sub-primary;
            svg {
              fill: $sub-primary;
            }
          }
        }
      }
    }
  }
  .slide-enter-active {
    transition: 0.3s ease-in;
  }
  .slide-leave-active {
    transition-duration: 0.3s;
    transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  }
  .slide-enter-to,
  .slide-leave {
    overflow: hidden;
    transform: translate(0, 0);
  }
  .slide-enter,
  .slide-leave-to {
    overflow: hidden;
    transform: translate(100%, 0);
  }
}
</style>
